/* Auto-generated from ropa/country_masterdata_eu_2026.csv — do not edit by hand. */

export type RopaCountryMasterdata = {
  name: string;
  iso2: string;
  isEu: boolean;
  isEea: boolean;
  isGdprThirdCountry: boolean;
  requiresTia: boolean;
  isBaseCountryInUi: boolean;
  sortingGroup: number;
};

const ROPA_COUNTRY_MASTERDATA: RopaCountryMasterdata[] = [
  {
    name: 'Afghanistan',
    iso2: 'AF',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 6,
  },
  {
    name: 'Albanien',
    iso2: 'AL',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Algeriet',
    iso2: 'DZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Amerikanska Samoa',
    iso2: 'AS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Andorra',
    iso2: 'AD',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'Angola',
    iso2: 'AO',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Anguilla',
    iso2: 'AI',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Antarktis',
    iso2: 'AQ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Antigua och Barbuda',
    iso2: 'AG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Argentina',
    iso2: 'AR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'Armenien',
    iso2: 'AM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Aruba',
    iso2: 'AW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Australien',
    iso2: 'AU',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 3,
  },
  {
    name: 'Azerbajdzjan',
    iso2: 'AZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Bahamas',
    iso2: 'BS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Bahrain',
    iso2: 'BH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Bangladesh',
    iso2: 'BD',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Barbados',
    iso2: 'BB',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Belarus (Vitryssland)',
    iso2: 'BY',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 6,
  },
  {
    name: 'Belgien',
    iso2: 'BE',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Belize',
    iso2: 'BZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Benin',
    iso2: 'BJ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Bermuda',
    iso2: 'BM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Bhutan',
    iso2: 'BT',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Bolivia',
    iso2: 'BO',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Bosnien och Hercegovina',
    iso2: 'BA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Botswana',
    iso2: 'BW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Brasilien',
    iso2: 'BR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'Brittiska Jungfruöarna',
    iso2: 'VG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Brunei',
    iso2: 'BN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Bulgarien',
    iso2: 'BG',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Burkina Faso',
    iso2: 'BF',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Burundi',
    iso2: 'BI',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Centralafrikanska republiken',
    iso2: 'CF',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Chile',
    iso2: 'CL',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Colombia',
    iso2: 'CO',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Cooköarna',
    iso2: 'CK',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Costa Rica',
    iso2: 'CR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Cypern',
    iso2: 'CY',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Danmark',
    iso2: 'DK',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 1,
  },
  {
    name: 'Djibouti',
    iso2: 'DJ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Dominica',
    iso2: 'DM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Dominikanska republiken',
    iso2: 'DO',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Ecuador',
    iso2: 'EC',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Egypten',
    iso2: 'EG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Ekvatorialguinea',
    iso2: 'GQ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'El Salvador',
    iso2: 'SV',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Elfenbenskusten',
    iso2: 'CI',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Eritrea',
    iso2: 'ER',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Estland',
    iso2: 'EE',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Eswatini (Swaziland)',
    iso2: 'SZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Etiopien',
    iso2: 'ET',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Falklandsöarna',
    iso2: 'FK',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Fiji',
    iso2: 'FJ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Filippinerna',
    iso2: 'PH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Finland',
    iso2: 'FI',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 1,
  },
  {
    name: 'Frankrike',
    iso2: 'FR',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Franska Guyana',
    iso2: 'GF',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 2,
  },
  {
    name: 'Franska Polynesien',
    iso2: 'PF',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Gabon',
    iso2: 'GA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Gambia',
    iso2: 'GM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Georgien',
    iso2: 'GE',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Ghana',
    iso2: 'GH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Gibraltar',
    iso2: 'GI',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Grekland',
    iso2: 'GR',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Grenada',
    iso2: 'GD',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Grönland',
    iso2: 'GL',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Guadeloupe',
    iso2: 'GP',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 2,
  },
  {
    name: 'Guam',
    iso2: 'GU',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Guatemala',
    iso2: 'GT',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Guernsey',
    iso2: 'GG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'Guinea',
    iso2: 'GN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Guinea-Bissau',
    iso2: 'GW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Guyana',
    iso2: 'GY',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Haiti',
    iso2: 'HT',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Honduras',
    iso2: 'HN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Hongkong',
    iso2: 'HK',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Indien',
    iso2: 'IN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: true,
    sortingGroup: 3,
  },
  {
    name: 'Indonesien',
    iso2: 'ID',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Irak',
    iso2: 'IQ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Iran',
    iso2: 'IR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 6,
  },
  {
    name: 'Irland',
    iso2: 'IE',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Island',
    iso2: 'IS',
    isEu: false,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 1,
  },
  {
    name: 'Isle of Man',
    iso2: 'IM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'Israel',
    iso2: 'IL',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'Italien',
    iso2: 'IT',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Jamaica',
    iso2: 'JM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Japan',
    iso2: 'JP',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 3,
  },
  {
    name: 'Jersey',
    iso2: 'JE',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'Jordanien',
    iso2: 'JO',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Julön',
    iso2: 'CX',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kambodja',
    iso2: 'KH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kamerun',
    iso2: 'CM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kanada',
    iso2: 'CA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 3,
  },
  {
    name: 'Kap Verde',
    iso2: 'CV',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kazakstan',
    iso2: 'KZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kenya',
    iso2: 'KE',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kina',
    iso2: 'CN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: true,
    sortingGroup: 6,
  },
  {
    name: 'Kirgizistan',
    iso2: 'KG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kiribati',
    iso2: 'KI',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kokosöarna',
    iso2: 'CC',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Komorerna',
    iso2: 'KM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kongo, Demokratiska Rep.',
    iso2: 'CD',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kongo, Republiken',
    iso2: 'CG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kosovo',
    iso2: 'XK',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kroatien',
    iso2: 'HR',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Kuba',
    iso2: 'CU',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Kuwait',
    iso2: 'KW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Laos',
    iso2: 'LA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Lesotho',
    iso2: 'LS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Lettland',
    iso2: 'LV',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Libanon',
    iso2: 'LB',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Liberia',
    iso2: 'LR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Libyen',
    iso2: 'LY',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Liechtenstein',
    iso2: 'LI',
    isEu: false,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Litauen',
    iso2: 'LT',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Luxemburg',
    iso2: 'LU',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Macao',
    iso2: 'MO',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Madagaskar',
    iso2: 'MG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Malawi',
    iso2: 'MW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Malaysia',
    iso2: 'MY',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Maldiverna',
    iso2: 'MV',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Mali',
    iso2: 'ML',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Malta',
    iso2: 'MT',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Marocko',
    iso2: 'MA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Marshallöarna',
    iso2: 'MH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Martinique',
    iso2: 'MQ',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 2,
  },
  {
    name: 'Mauretanien',
    iso2: 'MR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Mauritius',
    iso2: 'MU',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Mayotte',
    iso2: 'YT',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 2,
  },
  {
    name: 'Mexiko',
    iso2: 'MX',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Mikronesien',
    iso2: 'FM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Moçambique',
    iso2: 'MZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Moldavien',
    iso2: 'MD',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Monaco',
    iso2: 'MC',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Mongoliet',
    iso2: 'MN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Montenegro',
    iso2: 'ME',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Montserrat',
    iso2: 'MS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Myanmar (Burma)',
    iso2: 'MM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 6,
  },
  {
    name: 'Namibia',
    iso2: 'NA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Nauru',
    iso2: 'NR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Nederländerna',
    iso2: 'NL',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Nepal',
    iso2: 'NP',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Nicaragua',
    iso2: 'NI',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Niger',
    iso2: 'NE',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Nigeria',
    iso2: 'NG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Niue',
    iso2: 'NU',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Nordkorea',
    iso2: 'KP',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 6,
  },
  {
    name: 'Nordmakedonien',
    iso2: 'MK',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Nordmarianerna',
    iso2: 'MP',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Norfolkön',
    iso2: 'NF',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Norge',
    iso2: 'NO',
    isEu: false,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 1,
  },
  {
    name: 'Nya Kaledonien',
    iso2: 'NC',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Nya Zeeland',
    iso2: 'NZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'Oman',
    iso2: 'OM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Pakistan',
    iso2: 'PK',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Palau',
    iso2: 'PW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Palestina',
    iso2: 'PS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Panama',
    iso2: 'PA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Papua Nya Guinea',
    iso2: 'PG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Paraguay',
    iso2: 'PY',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Peru',
    iso2: 'PE',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Pitcairnöarna',
    iso2: 'PN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Polen',
    iso2: 'PL',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Portugal',
    iso2: 'PT',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Puerto Rico',
    iso2: 'PR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Qatar',
    iso2: 'QA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Réunion',
    iso2: 'RE',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 2,
  },
  {
    name: 'Rumänien',
    iso2: 'RO',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Rwanda',
    iso2: 'RW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Ryssland',
    iso2: 'RU',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 6,
  },
  {
    name: 'Saint Barthélemy',
    iso2: 'BL',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Saint Helena',
    iso2: 'SH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Saint Kitts och Nevis',
    iso2: 'KN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Saint Lucia',
    iso2: 'LC',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Saint Martin',
    iso2: 'MF',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Saint Pierre och Miquelon',
    iso2: 'PM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Saint Vincent/Grenadinerna',
    iso2: 'VC',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Salomonöarna',
    iso2: 'SB',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Samoa',
    iso2: 'WS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'San Marino',
    iso2: 'SM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'São Tomé och Príncipe',
    iso2: 'ST',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Saudiarabien',
    iso2: 'SA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Schweiz',
    iso2: 'CH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 3,
  },
  {
    name: 'Senegal',
    iso2: 'SN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Serbien',
    iso2: 'RS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Seychellerna',
    iso2: 'SC',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Sierra Leone',
    iso2: 'SL',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Singapore',
    iso2: 'SG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 3,
  },
  {
    name: 'Sint Maarten',
    iso2: 'SX',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Slovakien',
    iso2: 'SK',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Slovenien',
    iso2: 'SI',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Somalia',
    iso2: 'SO',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Spanien',
    iso2: 'ES',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Sri Lanka',
    iso2: 'LK',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Storbritannien',
    iso2: 'GB',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 3,
  },
  {
    name: 'Sudan',
    iso2: 'SD',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Surinam',
    iso2: 'SR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Svalbard och Jan Mayen',
    iso2: 'SJ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Sverige',
    iso2: 'SE',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 1,
  },
  {
    name: 'Sydafrika',
    iso2: 'ZA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Sydgeorgien/Sydsandwichö.',
    iso2: 'GS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Sydkorea',
    iso2: 'KR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 3,
  },
  {
    name: 'Sydsudan',
    iso2: 'SS',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Syrien',
    iso2: 'SY',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 6,
  },
  {
    name: 'Tadzjikistan',
    iso2: 'TJ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Taiwan',
    iso2: 'TW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Tanzania',
    iso2: 'TZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Tchad',
    iso2: 'TD',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Thailand',
    iso2: 'TH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Tjeckien',
    iso2: 'CZ',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Togo',
    iso2: 'TG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Tokelau',
    iso2: 'TK',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Tonga',
    iso2: 'TO',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Trinidad och Tobago',
    iso2: 'TT',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Tunisien',
    iso2: 'TN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Turkiet',
    iso2: 'TR',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Turkmenistan',
    iso2: 'TM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Turks- och Caicosöarna',
    iso2: 'TC',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Tuvalu',
    iso2: 'TV',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Tyskland',
    iso2: 'DE',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Uganda',
    iso2: 'UG',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Ukraina',
    iso2: 'UA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Ungern',
    iso2: 'HU',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Uruguay',
    iso2: 'UY',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 4,
  },
  {
    name: 'USA',
    iso2: 'US',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 3,
  },
  {
    name: 'USA:s yttre öar',
    iso2: 'UM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Uzbekistan',
    iso2: 'UZ',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Vanuatu',
    iso2: 'VU',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Vatikanstaten',
    iso2: 'VA',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Venezuela',
    iso2: 'VE',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Vietnam',
    iso2: 'VN',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Västsahara',
    iso2: 'EH',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Wallis- och Futunaöarna',
    iso2: 'WF',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Yemen',
    iso2: 'YE',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Zambia',
    iso2: 'ZM',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Zimbabwe',
    iso2: 'ZW',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
  {
    name: 'Åland',
    iso2: 'AX',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: false,
    sortingGroup: 1,
  },
  {
    name: 'Österrike',
    iso2: 'AT',
    isEu: true,
    isEea: true,
    isGdprThirdCountry: false,
    requiresTia: false,
    isBaseCountryInUi: true,
    sortingGroup: 2,
  },
  {
    name: 'Östtimor',
    iso2: 'TL',
    isEu: false,
    isEea: false,
    isGdprThirdCountry: true,
    requiresTia: true,
    isBaseCountryInUi: false,
    sortingGroup: 5,
  },
];

export const getRopaCountryClassification = (iso2: string): string => {
  const country = ROPA_COUNTRY_MASTERDATA.find(item => item.iso2 === iso2.toUpperCase());
  if (!country) return 'unknown';
  if (country.isEu || country.isEea) return 'eu_eea';
  if (country.requiresTia) return 'third_country_tia';
  if (country.isGdprThirdCountry) return 'third_country';
  return 'other';
};

export const getRopaCountriesForUi = (): RopaCountryMasterdata[] =>
  [...ROPA_COUNTRY_MASTERDATA].sort((left, right) => {
    if (left.isBaseCountryInUi !== right.isBaseCountryInUi) return left.isBaseCountryInUi ? -1 : 1;
    if (left.sortingGroup !== right.sortingGroup) return left.sortingGroup - right.sortingGroup;
    return left.name.localeCompare(right.name);
  });

export default ROPA_COUNTRY_MASTERDATA;
